import { useTranslation } from "react-i18next";
import { useOrderingStore } from "../../store/use-ordering-store";
import { formatFullName } from "../../utils/format-full-name";
import { formatPhoneNumber } from "../../utils/format-phone-number";

type SummaryPersonalDetailsProps = {
  showFullName?: boolean;
};
export const SummaryPersonalDetails = ({ showFullName = true }: SummaryPersonalDetailsProps) => {
  const { t } = useTranslation();
  const { personalDetails } = useOrderingStore();
  if (!personalDetails) return null;

  const renderDetailItem = (label: string, value: string) => (
    <div>
      <p className="text-muted-foreground text-sm">{label}</p>
      <p className="text-foreground">{value}</p>
    </div>
  );

  const fullName = formatFullName(personalDetails.firstName, personalDetails.lastName);
  const phoneNumber = formatPhoneNumber(personalDetails.phone, personalDetails.dialCode);
  const identificationInfo = personalDetails.pesel
    ? { label: t("GROUP_ACTIONS_ORDERING.SUMMARY.PESEL"), value: personalDetails.pesel }
    : {
        label: t("GROUP_ACTIONS_ORDERING.SUMMARY.DATE_OF_BIRTH"),
        value: personalDetails.dateOfBirth || "-",
      };

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {showFullName && renderDetailItem(t("GROUP_ACTIONS_ORDERING.SUMMARY.FULL_NAME"), fullName)}
      {renderDetailItem(identificationInfo.label, identificationInfo.value)}
      {personalDetails.email && renderDetailItem(t("GROUP_ACTIONS_ORDERING.SUMMARY.EMAIL"), personalDetails.email)}
      {renderDetailItem(t("GROUP_ACTIONS_ORDERING.SUMMARY.PHONE_NUMBER"), phoneNumber)}
    </div>
  );
};
